// The order-payment-detail inline Bank Statement editor has no form field to
// surface backend errors in, so its 422s (e.g. "bank statement not found")
// must be raised as a notification instead. Returns the joined
// bank_statement_id messages, or null when the error is not about the bank
// statement (those keep rendering through the edit modal's field errors).
export const bankStatementErrorMessage = (errorDescription) => {
    if (!errorDescription || typeof errorDescription === 'string') return null

    const messages = errorDescription.bank_statement_id
    if (!messages || messages.length === 0) return null

    return [].concat(messages).join(', ')
}
